import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';

import { CompaniesService } from '@services/companies.service';
import { AppLayoutService } from '@app/modules/app-layout/app-layout.service';
import { CompanyModel, SelfFilerModel } from '@data-layer/models/companies';
import { SelfFilerRepository } from '@data-layer/repositories';
import { SelfFilerService } from '@services/self-filer.service';
import { enumFilerCodeState } from '@enum/enumFilerCodeState';

@Component({
  selector: 'company-cbp-connection',
  templateUrl: './company-cbp-connection.component.html',
  styleUrls: ['./company-cbp-connection.component.scss'],
})
export class CompanyCbpConnectionComponent implements OnInit, OnDestroy {
  public company: CompanyModel;
  public cbpConnectionsInfo: SelfFilerModel;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(
    private companiesService: CompaniesService,
    private appLayoutService: AppLayoutService,
    private selfFilerRepository: SelfFilerRepository,
    private selfFilerService: SelfFilerService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.appLayoutService.contentHeader$.next({ title: [{ key: 'PAGE.ON_BOARDING.PROFILE_HEADER', link: null }] });

    this.companiesService.companyChange$.pipe(takeUntil(this.isDestroy)).subscribe((companyChange) => {
      this.company = companyChange.current;
      const isShow = this.selfFilerService.isShowOnBoarding;
      if (isShow) {
        this.updateConnectionsInfo();
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public get hasFilerCode(): boolean {
    return (
      this.cbpConnectionsInfo &&
      this.selfFilerService.getOnBoardingObjectState(this.cbpConnectionsInfo.filerCodeDetails) === enumFilerCodeState.SUCCESS
    );
  }

  public updateCompany() {
    this.updateConnectionsInfo();
  }

  public updateAbiTransmitter(value: boolean) {
    this.selfFilerRepository
      .sendAbiTransmitterUpdateApproved(this.company.id, value)
      .pipe(
        take(1),
        tap(() => this.updateConnectionsInfo),
      )
      .subscribe();
  }

  private updateConnectionsInfo() {
    this.selfFilerRepository
      .getSelfFiler(this.company.id)
      .pipe(take(1))
      .subscribe((info) => {
        this.cbpConnectionsInfo = info;
      });
  }
}
